export function dateFormatter(activityDate) {
  const date = new Date(Date.parse(activityDate));
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();

  return `${day}.${month}.${year}`;
}
